<div class="page-not-found">
  <app-header></app-header>
  <div class="page-not-found__content">
    <img src="../../../assets/img/oops.svg" alt="No encontrado" width="300" height="300" />
    <pichincha-typography
      variant="prelo-slab"
      weight="600"
      size="28px"
      line-height="40px"
      color="bp-primary-blue500"
      >Esta página no existe</pichincha-typography
    >
    <br />
    <pichincha-typography
      variant="prelo"
      weight="400"
      size="16px"
      line-height="24px"
      color="bp-grayScale500"
      >Es posible que el enlace no exista o se haya eliminado la página.</pichincha-typography
    >
    <br />
    <pichincha-button
      label="Ir al inicio"
      size="large"
      (click)="handleRedirect()"
    ></pichincha-button>
  </div>
  <app-footer></app-footer>
</div>
